import { IApplicationState } from 'shared/map-search/types/redux';

export function selectSource(state: IApplicationState): string | undefined {
  return state.source;
}
